// @flow
import {
    CREATE_TICKET,
    HIDE_TICKET_FORM,
    HIDE_TICKET_MODAL,
    PERSIST_TICKET,
    PERSIST_TICKET_FORM_DATA,
    REMOVE_TICKET_FROM_LIST,
    SET_STATUS_FILTERS,
    SET_TICKET_LIST,
    SET_TICKET_TYPE,
    SHOW_TICKET_FORM,
    SHOW_TICKET_MODAL,
    UPDATE_TICKET_DATA,
    UPDATE_TICKET_FORM_DATA,
    UPDATE_TICKET_IN_LIST
} from '../actions/tickets';

import type { Action } from './types';

const initialState = {
    visibleTicketModal: false,
    ticketData: {},
    ticketType: [ { id: "assigned", value: localStorage.getItem( 'username' ) } ],
    ticketList: [],
    ticketForm: [],
    statusFilters: []
};

const compare = ( a, b ) => {
    const objA = a.id;
    const objB = b.id;

    let comparison = 0;
    if ( objA > objB ) {
        comparison = 1;
    } else if ( objA < objB ) {
        comparison = -1;
    }
    return comparison;
}

//Reducer that manages the sidePanel visibility
export default function ui( state = initialState, action: Action ) {
    switch ( action.type ) {

        case SHOW_TICKET_MODAL:
            return { ...state, visibleTicketModal: true, ticketData: action.payload };

        case HIDE_TICKET_MODAL:
            return { ...state, visibleTicketModal: false, ticketData: [] };

        case UPDATE_TICKET_DATA:
            return {
                ...state,
                ticketData: {
                    ...state.ticketData,
                    [action.payload.name]: action.payload.value
                }
            };

        case CREATE_TICKET:
            return { ...state, visibleTicketModal: true, ticketData: [] };

        case PERSIST_TICKET:
            return { ...state, ticketData: action.payload };

        case SET_TICKET_TYPE:
            return { ...state, ticketType: action.payload };

        case SET_TICKET_LIST:
            return { ...state, ticketList: action.payload };

        case SHOW_TICKET_FORM:
            return { ...state, visibleTicketForm: true, ticketFormData: action.payload };

        case HIDE_TICKET_FORM:
            return { ...state, visibleTicketForm: false };

        case UPDATE_TICKET_FORM_DATA:
            return {
                ...state,
                ticketFormData: {
                    ...state.ticketFormData,
                    [action.payload.name]: action.payload.value
                }
            };

        case UPDATE_TICKET_IN_LIST:
            const filteredTicketList = state.ticketList.filter( item => item.id !== action.payload.id );
            const newTicketList = [ action.payload, ...filteredTicketList ].sort( compare );
            return {
                ...state,
                ticketList: newTicketList
            };
        case REMOVE_TICKET_FROM_LIST:
            const filteredTicketListAfterRemove = state.ticketList.filter(item => item.id !== action.payload);
            return {
                ...state,
                ticketList: filteredTicketListAfterRemove
            }

        case PERSIST_TICKET_FORM_DATA:
            return { ...state, ticketFormData: action.payload };
        case SET_STATUS_FILTERS:
            return {
                ...state,
                statusFilters: action.payload
            }
        default:
            return state;
    }
}
